import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { getNetworkError } from 'common/utils';

import {
  generateGalleryImageDescription as generateGalleryImageDescriptionApi,
  getGalleryImages as getGalleryImagesApi,
  updateGalleryImage as updateGalleryImageApi,
} from '../../api';

const SET_STATUS = 'gallery/SET_STATUS';
const SET_VIEW = 'gallery/SET_VIEW';
const SELECT_IMAGE = 'gallery/SELECT_IMAGE';
const GET_IMAGES = 'gallery/GET_IMAGES';
const UPDATE_IMAGE = 'gallery/UPDATE_IMAGE';
const GENERATE_DESCRIPTION = 'gallery/GENERATE_DESCRIPTION';

export const setStatus = createAction(SET_STATUS);

/** Change the search term, named filter, or page. */
export const setView = createAction(SET_VIEW);

export const selectImage = createAction(SELECT_IMAGE);

export const getImages = createAsyncThunk(GET_IMAGES, async (view = {}, { getState }) => {
  try {
    const { search, filter, page, perPage } = { ...getState().gallery.view, ...view };
    return await getGalleryImagesApi({ search, filter, page, perPage });
  } catch (err) {
    Sentry.captureException(err);
    throw new Error(getNetworkError(err));
  }
});

export const updateImage = createAsyncThunk(UPDATE_IMAGE, async ({ imageId, description, confirmed }) => {
  try {
    return await updateGalleryImageApi(imageId, { description, confirmed });
  } catch (err) {
    Sentry.captureException(err);
    throw new Error(getNetworkError(err));
  }
});

/**
 * Generate a description with AI. Resolves with the image so the reducer can patch
 * it in place; the server returns the image unchanged when it declines to describe
 * it, so the caller does not need to distinguish the two.
 */
export const generateDescription = createAsyncThunk(GENERATE_DESCRIPTION, async ({ imageId, force = false }) => {
  try {
    return await generateGalleryImageDescriptionApi(imageId, { force });
  } catch (err) {
    Sentry.captureException(err);
    throw new Error(getNetworkError(err));
  }
});
